const Service = require('gui/inputs/service');
module.exports = class MediaService extends Service {
  constructor(opts = {}) {
    super(opts);
  }
};
